import React, { useMemo } from 'react';
import DropDownSearchable from '../../dropDownSearchable';
import { convertKeyToLabel } from '../../../utilities/stringHelpers';

const removeIdText = (str) => str.replace(/_id/g, '');

const UtilitiesCard = ({ project, onUpdate }) => {
    const { ProjectUtilitiesConfiguration, init } = project;

    const fields = useMemo(() => {
        return Object.keys(ProjectUtilitiesConfiguration)
            .filter((util) => util !== 'project_id')
            .map((util) => ({
                config_name: util,
                label: convertKeyToLabel(removeIdText(util)),
                options: init.utilities_options[util].map((opt) => ({
                    value: opt.id,
                    label: opt.name,
                })),
            }));
    }, [ProjectUtilitiesConfiguration]);

    const findSelected = (field) => {
        const varName = field.config_name;
        const projectValue = ProjectUtilitiesConfiguration[varName];
        return field.options.find((opt) => opt.value === projectValue);
    };

    const handleSelect = (field, selected) => {
        onUpdate([
            {
                sectionName: 'ProjectUtilitiesConfiguration',
                fieldName: field.config_name,
                value: Number(selected.value),
            },
        ]);
    };

    return (
        <div>
            <h3 className="cardTitle">Utilities</h3>
            {fields.map((field) => (
                <div
                    key={`utilitiescfg-${field.config_name}`}
                    className="mb-1 d-flex justify-content-between align-items-center"
                >
                    <label className="fieldLabel">{field.label}</label>
                    <div className="w-50" style={{ minWidth: '50%' }}>
                        <DropDownSearchable
                            options={field.options}
                            value={findSelected(field)}
                            onSelect={(selected) => handleSelect(field, selected)}
                            compact={true}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UtilitiesCard;
